import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { default as axios } from '../axiosConfig';
import { Box, CircularProgress, Typography } from '@mui/material';
import { API_ResetPassword } from '../Assets/ApiUrlContainer';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const resetPassword = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await axios.post(API_ResetPassword, { token });
        if (response.data.message) {
          navigate('/thank-you'); // Redirect to the Thank You page
        }
      } catch (err) {
        setError(err.response?.data?.error || 'An error occurred.');
      } finally {
        setLoading(false);
      }
    };
  
    if (token) {
      resetPassword();
    }
  }, [token, navigate]);  

  return (
    <Box style={{ padding: '20px', maxWidth: '600px', margin: 'auto', textAlign: 'center' }}>
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <Typography variant="h6">Processing your request...</Typography>
      )}
    </Box>
  );
};

export default ResetPasswordPage;